module.exports = __webpack_public_path__ + "img/photography.7f595bbc.png";